module.exports = __webpack_public_path__ + "static/media/metamask.dd125548.svg";